// extracted by mini-css-extract-plugin
export default {"noKeyDealsImage":"TeamDetailsTab_noKeyDealsImage__Pu4lV"};